import type {
  AddressSystemDialogState,
  AddressSystemMenuState,
  DialogContentState,
  StateOfMap,
} from '@/types/address-system'

// Generic для заведения состояний констант
type GeneralStates<T> = { [key: string]: T }

/**
 * Состояния меню адресной системы
 */
export const STATE_MENU_ADDRESS_SYSTEM: GeneralStates<AddressSystemMenuState> =
  {
    SUGGESTIONS: 'suggestions',
    SELECTED: 'selected',
    ERROR: 'error',
    DEFAULT: 'default',
    LOADING: 'loading',
    NOT_DELIVERY: 'not-delivery',
    NOT_GEO: 'not-geo',
  }

/**
 * Состояния ДО адрессной системы
 */
export const STATE_DIALOG_ADDRESS_SYSTEM: GeneralStates<AddressSystemDialogState> =
  {
    LOADING: 'loading',
    ERROR: 'error',
    READY: 'ready',
  }

/**
 * Состояния ДО адрессной системы
 */
export const STATE_CONTENT_ADDRESS_SYSTEM: GeneralStates<DialogContentState> = {
  NEW: 'new',
  SELECT: 'select',
  REDIRECT: 'redirect',
}

/**
 * Состояния карты
 */
export const STATE_OF_MAP: GeneralStates<StateOfMap> = {
  loading: 'pending',
  loaded: 'loaded',
  error: 'error',
}

export const BALLOON_TEXT = {
  outsideDelivery: 'Вне зоны доставки',
  addressNotFound: 'Не удалось определить адрес',
  determineAddress: 'Определите адрес доставки',
  default: '',
}
